import { Dispatch } from 'redux'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { RootState } from "../../store/rootReducer"
import { apiInstance } from "../../api/apiInstance"
import anchor from '../../../constants/anchor'

const searchCarListBodyTypes = (
    searchTerm: string
) => async (
    dispatch: Dispatch,
    getState: () => RootState,
): Promise<void> => {
    const { userData } = getState()
    const params = {
        userId: userData.smsAuth.userId,
        search: searchTerm,
    }
    const config = {
        headers: { Authorization: `${anchor} ${localStorage.getItem('accessToken')}` }
    }
    try {
        const { data: { status, bodyTypes } } = await apiInstance.post('/getCarsSelectSearchBodyType', params, config)
        if (status === 'ok') {
            dispatch({
                type: storeDispatchTypes.setBodyTypesCars,
                value: {
                    bodyTypes
                }
            })
        }
    } catch (e) {
        console.error('load cars body types failed', e)
    }
}

export default searchCarListBodyTypes
